// import tinymce from './tinymce.js';

// import './icons/default';
// import './langs/sk.js';
// import './models/dom';
// import './themes/silver';

// import './skins/ui/oxide/skin.css';
// // import './skins/ui/oxide/content.css';
// // import './skins/content/default/content.css';
// // import tinymceContentUiCss from '!!css-loader!./skins/ui/oxide/content.css';
// // import tinymceContentCss from '!!css-loader!./skins/content/default/content.css';
// import tinymceContentUiCss from './skins/ui/oxide/content.css?inline';
// import tinymceContentCss from './skins/content/default/content.css?inline';

// import './plugins/advlist';
// import './plugins/anchor';
// import './plugins/autolink';
// import './plugins/autoresize';
// import './plugins/autosave';
// import './plugins/code';
// import './plugins/codesample';
// import './plugins/directionality';
// import './plugins/emoticons';
// import './plugins/emoticons/js/emojis.js';
// import './plugins/emoticons/js/emojiimages.js';
// import './plugins/fullscreen';
// import './plugins/help';
// import './plugins/charmap';
// import './plugins/image';
// import './plugins/importcss';
// import './plugins/insertdatetime';
// import './plugins/link';
// import './plugins/lists';
// import './plugins/media';
// import './plugins/nonbreaking';
// import './plugins/pagebreak';
// import './plugins/preview';
// import './plugins/quickbars';
// import './plugins/save';
// import './plugins/searchreplace';
// import './plugins/table';
// import './plugins/template';
// import './plugins/visualblocks';
// import './plugins/visualchars';
// import './plugins/wordcount';

// import './external_plugins/font_size_buttons/plugin.js';
// import './external_plugins/image_upload/plugin.js';

// export {
//     tinymce,
//     tinymceContentUiCss,
//     tinymceContentCss,
// };

// import './skins/ui/oxide/skin.css';
// let tinymceContentCss = null;
// let tinymceContentUiCss = null;

(() => {
    if (typeof document == 'undefined') {
        return;
    }
    const tinymce = require('./tinymce.js');

    require('./icons/default');
    require('./langs/sk.js');
    require('./models/dom');
    require('./themes/silver');

    require('./skins/ui/oxide/content.js');
    require('./skins/content/default/content.js');

    require('./plugins/advlist');
    require('./plugins/anchor');
    require('./plugins/autolink');
    require('./plugins/autoresize');
    require('./plugins/autosave');
    require('./plugins/code');
    require('./plugins/codesample');
    require('./plugins/directionality');
    require('./plugins/emoticons');
    require('./plugins/emoticons/js/emojis.js');
    require('./plugins/emoticons/js/emojiimages.js');
    require('./plugins/fullscreen');
    require('./plugins/help');
    require('./plugins/charmap');
    require('./plugins/image');
    require('./plugins/importcss');
    require('./plugins/insertdatetime');
    require('./plugins/link');
    require('./plugins/lists');
    require('./plugins/media');
    require('./plugins/nonbreaking');
    require('./plugins/pagebreak');
    require('./plugins/preview');
    require('./plugins/quickbars');
    require('./plugins/save');
    require('./plugins/searchreplace');
    require('./plugins/table');
    require('./plugins/template');
    require('./plugins/visualblocks');
    require('./plugins/visualchars');
    require('./plugins/wordcount');

    require('./external_plugins/font_size_buttons/plugin.js');
    require('./external_plugins/image_upload/plugin.js');
})();
